import React, { useMemo } from 'react'
import { actionAtom } from 'atoms/atoms'
import { useAtomValue } from 'jotai'
import { Sheet } from '@node-space/ui-components'
import { ActionIds } from 'types/types'
import { ApiKeyCreate } from './components/ApiKeyCreate/ApiKeyCreate'
import { ApiKeyManage } from './components/ApiKeyManage/ApiKeyManage'

interface ApiKeySheetProps {
  isSheetOpen: boolean
  from2FA: boolean
}

export const ApiKeySheet = ({ isSheetOpen, from2FA }: ApiKeySheetProps) => {
  const apiKeySheetAction = useAtomValue(actionAtom)
  const { onBack, header, subHeader, onClose } = apiKeySheetAction ?? {}

  const sheetContent = useMemo(() => {
    switch (apiKeySheetAction?.actionId) {
      case ActionIds.API_KEY_CREATE:
        return <ApiKeyCreate from2FA={from2FA} />
      case ActionIds.API_KEY_MANAGE:
        return <ApiKeyManage />
      default:
        return null
    }
  }, [apiKeySheetAction])

  return (
    <Sheet
      header={header}
      onBack={onBack}
      isOpen={isSheetOpen}
      onClose={onClose}
      subHeader={subHeader}
    >
      {sheetContent}
    </Sheet>
  )
}
